import { Component, OnInit } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { ActivatedRoute, Router } from "@angular/router";

import { AuthService } from "../../auth/auth.service";
import { TemplateService } from "../service/template.service";
import { TemplateList } from "../model/TemplateList";

// Entry point for RegHub's "open in AuditHub" link: audithub/regregister/:auditKey.
// The AuditKey (tblCustScoreSheetKeys.rhkey) stays the same across template upgrades, so it is
// resolved to the current csskey here, then the user is sent on to that template's Audit Summary.
@Component({
  selector: "app-open-audit",
  templateUrl: "./open-audit.component.html",
  styleUrls: ["./open-audit.component.css"],
  standalone: false,
})
export class OpenAuditComponent implements OnInit {
  // loading -> redirect to Audit Summary, or one of the friendly states: a non-"ok"
  // AuditKeyResolution.status, or "error".
  state: string = "loading";

  private static readonly GUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tpService: TemplateService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    const auditKey = this.route.snapshot.paramMap.get("auditKey") ?? "";
    if (!OpenAuditComponent.GUID.test(auditKey)) {
      this.state = "notfound";
      return;
    }

    this.tpService.resolveAuditKey(auditKey).subscribe(
      (res) => {
        if (res instanceof HttpErrorResponse) {
          // GlobalHttpInterceptorService swallows 401/403 (stale session) and redirects to
          // login itself; come back here afterwards.
          this.authService.setReturnUrl(this.router.url);
          return;
        }
        if (res?.status == "ok" && res.template) {
          this.openAuditSummary(res.template);
        } else {
          this.state = res?.status ?? "error";
        }
      },
      (err) => {
        console.error(err);
        this.state = "error";
      },
    );
  }

  // Set what EditTemplateComponent normally gets from the template list page (see
  // ApptoolComponent.onViewClick), before navigating so its ngOnInit can read it.
  private openAuditSummary(t: TemplateList) {
    this.tpService.setLinkedTemplate(t);
    this.tpService.setAuditName(
      t.auditName ?? "",
      t.facilityLocation ?? "",
      new Date(t.startDate).toDateString() +
        " - " +
        new Date(t.endDate).toDateString(),
      t.monitoring ?? "",
    );
    this.tpService.setDualLanguageTemplate(t.dualLanguage);
    this.tpService.setAuditPercentage(t.percentComplete ?? "0");

    // replaceUrl so Back from the Audit Summary doesn't bounce through this page again.
    this.router.navigateByUrl("audithub/apptool/edit/" + t.csskey, {
      replaceUrl: true,
    });
  }
}
